export default {
  list: {
    title: '账号中心',
    createButton: '创建账号',
    searchPlaceholder: '搜索用户名/邮箱',
    total: '共计',
    unit: '个',
    columns: {
      username: '用户名',
      email: '邮箱',
      department: '部署名称',
      role: '账号角色',
      careerRole: 'Career 角色',
      talentRole: 'Talent 角色',
      status: '状态',
      creator: '创建人',
      createTime: '创建时间',
      systemCreator: '系统添加',
      operations: '操作',
    },
    operations: {
      edit: '编辑',
      delete: '删除',
    },
  },
  createDialog: {
    title: '创建账号',
    editTitle: '编辑账号',
    create: '创建',
    save: '保存',
    username: '用户名',
    usernamePlaceholder: '请输入',
    email: '邮箱',
    emailPlaceholder: '请输入',
    department: '部署名称',
    departmentPlaceholder: '请输入',
    careerRole: 'Career',
    talentRole: 'Talent',
    careerRoleName: 'Career 角色',
    talentRoleName: 'Talent 角色',
    roleSelectPlaceholder: '请选择',
    admin: '管理员',
    normal: '普通账号',
    adminHint: '可创建改企业信息',
    normalHint: '仅管理已创建的员工及任务',
    cancel: '取消',
    confirm: '确定',
    validation: {
      usernameRequired: '请输入用户名',
      emailRequired: '请输入邮箱',
      emailInvalid: '邮箱格式不正确',
      emailExists: '账号已存在',
      emailExistsInOtherCompany: '该账号已加入其他企业，可联系原公司管理员移除或更换其他邮箱',
      departmentRequired: '请输入部署名称',
      roleRequired: '请选择角色',
      atLeastOneRole: '请至少选择一个角色',
    },
    fetchDetailError: '获取账号详情失败',
    fetchRolesError: '获取角色列表失败',
    saveAccountError: '保存账号失败',
  },
  status: {
    active: '已激活',
    unactive: '未激活',
    lock: '锁定',
  },
  deleteDialog: {
    title: '提示信息',
    content: '删除后不可恢复且账号无法登录系统，确定删除账号「{username}」吗？',
  },
  editDialog: {
    title: '提示信息',
    content: '不能编辑本人账号',
  },
  detail: {
    title: '个人信息',
    username: '用户名',
    email: '邮箱',
    password: '密码',
    department: '岗位名称',
    role: '角色',
    careerRole: 'Career角色',
    talentRole: 'Talent角色',
    save: '保存',
    cancel: '取消',
    updateEmail: '更换邮箱',
    modifyPassword: '修改密码',
  },
  updateEmailDialog: {
    title: '更换邮箱',
    step1Description: '请输入新的邮箱地址，我们将向新邮箱发送验证链接，通过链接验证后新邮箱地址生效',
    step2Description: '我们已向您的邮箱{email}发送了一封更换邮箱邮件，请注意接收邮件，并按照邮件中的提示操作。',
    inputPlaceholder: '请输入',
    cancel: '取消',
    confirm: '确定',
    known: '我知道了',
    validation: {
      emailRequired: '请输入邮箱',
    },
  },
  updatePasswordDialog: {
    title: '修改密码',
    oldPassword: '旧密码',
    newPassword: '新密码',
    confirmPassword: '再次输入新密码',
    inputPlaceholder: '请输入',
    newPasswordPlaceholder: '密码长度至少 8 位，需包含字母、数字',
    cancel: '取消',
    confirm: '确定',
    successMessage: '密码修改成功',
    validation: {
      oldPasswordRequired: '请输入旧密码',
      newPasswordRequired: '请输入新密码',
      passwordLength: '密码长度至少 8 位',
      passwordFormat: '密码需包含字母和数字',
      confirmPasswordRequired: '请再次输入新密码',
      passwordMismatch: '两次输入的密码不一致',
    },
  },
  messages: {
    updateSuccess: '修改成功',
  },
  roles: {
    superAdmin: '超级管理员',
    admin: '管理员',
    recruitManager: '管理员',
    recruiter: 'HR',
    user: '普通账号',
    interviewer: '面试官',
    op: '运营支持',
  },
  noPermission: '无权限',
  notPurchased: '暂未购买该产品，请联系销售人员',
  noRolePermission: '该账号在 {roleType} 中无任何权限。'
};
